var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_997)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_997)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2_997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.581 24.7749C33.8723 24.7749 35.0118 25.9144 35.0118 27.2058V36.9293C35.0118 38.2967 33.8723 39.3602 32.581 39.3602H27.7192C26.3519 39.3602 25.2883 38.2967 25.2883 36.9293V27.2058C25.2883 25.9144 26.3519 24.7749 27.7192 24.7749H32.581ZM31.3655 35.7139V28.4212H28.9346V35.7139H31.3655ZM44.7354 15.0514C46.0268 15.0514 47.1663 16.1909 47.1663 17.4823V36.9293C47.1663 38.2967 46.0268 39.3602 44.7354 39.3602H39.8736C38.5063 39.3602 37.4427 38.2967 37.4427 36.9293V17.4823C37.4427 16.1909 38.5063 15.0514 39.8736 15.0514H44.7354ZM43.5199 35.7139V18.6977H41.0891V35.7139H43.5199ZM20.4265 15.0514C21.7179 15.0514 22.8574 16.1909 22.8574 17.4823V36.9293C22.8574 38.2967 21.7179 39.3602 20.4265 39.3602H15.5648C14.1974 39.3602 13.1339 38.2967 13.1339 36.9293V17.4823C13.1339 16.1909 14.1974 15.0514 15.5648 15.0514H20.4265ZM19.2111 35.7139V18.6977H16.7802V35.7139H19.2111ZM8.27212 27.2058C9.56352 27.2058 10.703 28.3453 10.703 29.6367V36.9293C10.703 38.2967 9.56352 39.3602 8.27212 39.3602H3.41035C2.04297 39.3602 0.979462 38.2967 0.979462 36.9293V29.6367C0.979462 28.3453 2.04297 27.2058 3.41035 27.2058H8.27212ZM7.05667 35.7139V30.8521H4.62579V35.7139H7.05667ZM5.84123 19.9131C3.79017 19.9131 2.1949 18.3179 2.1949 16.2668C2.1949 14.2918 3.79017 12.6205 5.84123 12.6205C6.14509 12.6205 6.44895 12.6964 6.75281 12.7724L14.4253 5.09993C14.3493 4.79607 14.3493 4.49221 14.3493 4.11239C14.3493 2.1373 15.9446 0.466064 17.9957 0.466064C19.9707 0.466064 21.642 2.1373 21.642 4.11239C21.642 4.34029 21.566 4.49221 21.566 4.72011L28.7828 10.4935C29.2385 10.3415 29.6183 10.1896 30.0741 10.1896C30.6059 10.1896 30.9857 10.3415 31.4415 10.4935L38.6582 4.72011C38.6582 4.49221 38.6582 4.34029 38.6582 4.11239C38.6582 2.1373 40.2534 0.466064 42.3045 0.466064C44.2795 0.466064 45.9508 2.1373 45.9508 4.11239C45.9508 6.16346 44.2795 7.75872 42.3045 7.75872C41.7727 7.75872 41.3929 7.68276 40.9372 7.53082L33.7205 13.3041C33.7205 13.5321 33.7964 13.684 33.7964 13.8359C33.7964 15.887 32.1251 17.4823 30.1501 17.4823C28.099 17.4823 26.5038 15.887 26.5038 13.8359C26.5038 13.684 26.5038 13.5321 26.5038 13.3041L19.287 7.53082C18.8313 7.68276 18.4515 7.75872 17.9957 7.75872C17.6159 7.75872 17.312 7.75872 17.0081 7.68276L9.33563 15.3552C9.4116 15.6591 9.48756 15.963 9.48756 16.2668C9.48756 18.3179 7.81632 19.9131 5.84123 19.9131Z",
    fill: "#ED1C24"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.673,
    height: 38.8942,
    fill: "white",
    transform: "translate(0.979462 0.466064)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.673,
    height: 38.8942,
    fill: "white",
    transform: "translate(0.979462 0.466064)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.673,
    height: 38.8942,
    fill: "white",
    transform: "translate(0.979462 0.466064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.8337a7a40e84a7f8310686773061934f.svg";
export { ForwardRef as ReactComponent };